import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import Login from '../pages/Login/Login'
import MainRouting from './MainRouting/MainRouting';
import PrivateRoute from './PrivateRoute';

const AppRouter = () => {
  return (
    <Router>
    <Switch>
      <Route exact path="/" component={Login} />
      <PrivateRoute path="/main" component={MainRouting} />
    </Switch>
  </Router>
  )
}

export default AppRouter
